import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import VDatePicker4b from "./VDatePicker4b";
import axios from "axios";
//import "./css/global.css";
import "../index.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Fuse from "fuse.js";
import debounce from "lodash/debounce";
import { useMediaQuery } from "@mui/material";
import BookingSectionAutoCmplSmallScreen from "./BookingSectionAutoCmplSmallScreen";
import PlatformDetector from "../CommonGlobals/PlatformDetector";

import { FaTreeCity } from "react-icons/fa6";
import { MdLocationPin } from "react-icons/md";
import { TbRulerMeasure } from "react-icons/tb";
import { merge, orderBy, set } from "lodash";
import { CiSearch } from "react-icons/ci";

import { MISBookingMode } from "../CommonGlobals/TRMISBookingMode";

import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";

const formatDate = (date, separator) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}${separator}${month}${separator}${year}`;
};

const CommonSearchDateSection = ({
  config = null,
  BookingPageUrl = null,
  citiesDataUrl = "cities.json",
  onChangeConfigUrl = null,
  onChangeDestinationConfigUrl = null,
  dateSeparator = "-",
  monthDisplayType = "month",
  componentName = "home",
  onSearchModify,
  containerId = 'booking-section',
  autoSearch = 1
}) => {
  //const navigate = useNavigate();
  const [cityData, setCityData] = useState([]);
  const [processedCityData, setProcessedCityData] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const [openSource, setOpenSource] = useState(false);
  const [openDestination, setOpenDestination] = useState(false);

  // const [inputSource, setInputSource] = useState(""); // track typed value
  const [inputDestination, setInputDestination] = useState("");

  // this is the reults save
  const [searchSourceResults, setSearchSourceResults] = useState([]);
  const [searchDestinationResults, setSearchDestinationResults] = useState([]);

  const [isSourceOpen, setIsSourceOpen] = useState(false);
  const [isDestinationOpen, setIsDestinationOpen] = useState(false);

  const [dconfig, setDConfig] = useState(config || null);

  const desRef = useRef();
  const fromDateRef = useRef();
  const toDateRef = useRef();

  const destinationInputRef = useRef();
  const sourceContainerRef = useRef();
  const destinationContainerRef = useRef();

  const isMobile = useMediaQuery("(max-width:600px)");

  const [currentDate, setCurrentDate] = useState();

  const [openOnDestSelect, setOpenOnDestSelect] = useState(false);

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);

  const [autoSearchMode, setAutoSearchMode] = useState(autoSearch); // 0 = no auto search, 1 = auto search on both select and date change, 2 = auto search only on select

  useEffect(()=>{
    setAutoSearchMode(autoSearch);
  },[autoSearch]);
  // fetch city data
  function fetchCityData() {
   // console.log(citiesDataUrl);

    axios
      .get(citiesDataUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        //console.log(res);
        if (res.data) {
          //console.log(res.data);
        }
        const cd = JSON.parse(res.data.ResponseData);
       // console.log(cd);
        setCityData(cd);
        // //console.log(cd.cityList);
        // setSearchSourceResults(cd);
        // setSearchDestinationResults(cd);
      })
      .catch((err) => {
        console.log(err);
      });
  }

    useEffect(()=>{
      // console.log(processedCityData);
       setSearchSourceResults(processedCityData);
       setSearchDestinationResults(processedCityData);
  },[processedCityData]);

  useEffect(()=>{
     // console.log(searchSourceResults);
  },[searchSourceResults]);

  // Fuse instance
  const fuse = useMemo(() => {
    return new Fuse(processedCityData, {
      keys: ["CityName"],
      threshold: 0.2,
      distance: 3,
      minMatchCharLength: 2,
      ignoreLocation: true,
    });
  }, [processedCityData]);

  useEffect(() => {
    fetchCityData();
  }, [citiesDataUrl]);

  useEffect(() => {
    const cdate = formatDate(new Date(), dateSeparator);
    setSelectedFromDate(cdate);
    const parts = cdate.split(/\D+/);
    //console.log(parts);
    var day = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var year = parseInt(parts[2]);
    if (monthDisplayType == "number") {
      const cur_date3 = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
      setCurrentDate(cur_date3);
    } else {
      var dateObject = new Date(year, month - 1, day);
     // console.log(dateObject);
      const options = { month: "short" };
      const monthName = new Intl.DateTimeFormat("en-US", options).format(
        dateObject
      );
      const cur_date = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
      setCurrentDate(cur_date);
    }
  }, []);

  useEffect(() => {
    if (onChangeConfigUrl) {
      axios
        .get(onChangeConfigUrl, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
         // console.log(res);
          const cd = JSON.parse(res.data.d.data);
          setDConfig(cd);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [onChangeConfigUrl]);







//   const groupedCities = useMemo(() => {
//   const map = new Map();

//   cityData.forEach(c => {
//     if (!map.has(c.CityID)) {
//       map.set(c.CityID, {
//         CityID: c.CityID,
//         CityName: c.CityName,
//         ParentCityName: c.ParentCityName || c.CityName,
//         city: c,
//         boardingPoints: []
//       });
//     }

//     if (c.BoardingPointID !== 0) {
//       map.get(c.CityID).boardingPoints.push({
//         ...c,
//         isBoardingPoint: true
//       });
//     }
//   });

//   return Array.from(map.values());
// }, [cityData]);




  const groupedCities = useMemo(() => {
  const map = new Map();
 

  cityData.forEach(c => {
   
       const entry = {
        CityID: c.CityID,
        CityName: c.BoardingPointID === 0 ? c.CityName : c.BoardingPointName.includes(c.CityName) ? c.BoardingPointName : c.BoardingPointName + `, ${c.CityName}`,
        isBoardingPoint: c.BoardingPointID !== 0,
        BoardingPointID: c.BoardingPointID,
        ParentCityName: c.ParentCityName || c.CityName,
        IsPopularDestination: c.IsPopularDestination, 
      };

       
       if (!map.has(c.CityID)) {
        map.set(c.CityID, [entry]);
      } else {
        map.get(c.CityID).push(entry);
      }
    

    
  });

   const groupedData = Array.from(map.values());
   setProcessedCityData(groupedData.flat());
  
}, [cityData]);

//console.log(groupedCities.flat());

// const customSearch = useCallback(
//   (query) => {
//     console.log(groupedCities);
//      if (!query || query.trim() === "") {
     
//       return searchSourceResults;
//     }

//     const lower = query.toLowerCase();

//     // First fuzzy match parent cities
//     const mainMatches = fuse.search(query).map(r => r.item);

//     // if (mainMatches.length === 0) {
//     //   return []; // return empty array instead of previous results
//     // }

//     // Convert Fuse results into GROUPED results
//     const result = [];
   
//     // mainMatches.map(city => {
//     //   const group = groupedCities.find(g => g.CityID === city.CityID);
//     //   if (group) result.push(group);
//     // });

//     // const result = mainMatches
//     //   .map(r => groupedCities.find(g => g.CityID === r.item.CityID))
//     //   .filter(Boolean);

//     mainMatches.forEach(city => {
//       const group = groupedCities.find(g => g.CityID === city.CityID);
//       if (group) result.push(group);
//     });

//     return result;
//   },
//   [groupedCities, fuse]
// );





  const customSearch = useCallback(
    (query) => {
      if (!query) return processedCityData;

      const lowerQuery = query.toLowerCase();

      if (/^[a-z]$/i.test(query)) {
        return processedCityData?.filter((c) =>
          c.CityName.toLowerCase().startsWith(lowerQuery)
        );
      }

       const fuseResults = fuse.search(query).map((r) => r.item);

      if (fuseResults.length === 0) return []; 

      //  const grouped = Object.values(
      //   fuseResults.reduce((acc, city) => {
      //     if (!acc[city.CityID]) {
      //       acc[city.CityID] = [];
      //     }
      //     acc[city.CityID].push(city);
      //     return acc;
      //   }, {})
      // );

  

    
     return fuseResults;

    },
    [processedCityData, fuse]
  );

  // Debounced search updates searchResults state
const debouncedSourceSearch = useMemo(
  () =>
    debounce((query) => {
      const clean = customSearch(query);
     // console.log(clean);
      setSearchSourceResults(clean);  
    }, 300),
  [customSearch]
);


  // Debounced search updates searchResults state
  const debouncedDestinationSearch = useMemo(
    () =>
      debounce((query) => {
        let res = customSearch(query);
       // console.log(res);
        setSearchDestinationResults(customSearch(query));
      }, 500),
    [customSearch]
  );

  // filterOptions for Autocomplete
  const filterSourceOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    debouncedSourceSearch(inputValue);
    return searchSourceResults;
  };

  // filterOptions for Autocomplete
  const filterDestinationOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    debouncedDestinationSearch(inputValue);
    return searchDestinationResults;
  };

  const handleOnSelectOpen = () => {
    // destinationInputRef.current?.focus();
    // const event = new KeyboardEvent("keydown", { key: "tab", bubbles: true });
    // destinationInputRef.current?.dispatchEvent(event);
  };

  const handleOutsideClick = useCallback((event) => {
    const scontainer = sourceContainerRef.current;
    const dcontainer = destinationContainerRef?.current;

  //  console.log(event.target);

    // console.log(scontainer.contains(event.target));
    // console.log(dcontainer.contains(event.target));

    if (
      scontainer &&
      !scontainer.contains(event.target) &&
      dcontainer &&
      !dcontainer.contains(event.target)
    ) {
      if (event.target.closest(".autocomplete-item")) {
       // console.log("ya");
      } else {
        // console.log("no");
        setIsSourceOpen(false);
        setIsDestinationOpen(false);
      }

      // console.log(event.target.classList);
      // if(event.target.classList.contains('autocomplete-item')){
      //     console.log('ya');
      // }else{
      //   setIsSourceOpen(false);
      //   setIsDestinationOpen(false);
      // }

      // setIsSourceOpen(false);
      // setIsDestinationOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [handleOutsideClick]);

  const handleSwap = () => {
   // console.log(selectedSource);
    // console.log(selectedDestination);
    if (selectedSource != null && selectedDestination != null) {
      setSelectedSource(selectedDestination);
      setSelectedDestination(selectedSource);
    }
    // setSelectedSource(selectedDestination);
    // setSelectedDestination(selectedSource);
  };

  const handleOnSearchClick = () => {
    sendEventTobackend("SearchButtonClicked", null , 1);
    if(selectedToDate != null ){
      if(selectedFromDate == null || selectedFromDate == ''){
        alert('Please select Valid Journey date');
        return;
      }else{
        console.log(selectedFromDate);
        console.log(selectedToDate);
        const frmdt = selectedFromDate.replace(/[/-]/g, "-");
        const todt = selectedToDate.replace(/[/-]/g, "-");

        const reversedFrm = frmdt.split("-").reverse().join("-");
        const reversedTo = todt.split("-").reverse().join("-");  

        console.log(reversedFrm);
        console.log(reversedTo);

        const date1 = new Date(reversedFrm);
        const date2 = new Date(reversedTo);

        if (date1 >= date2) {
          alert("Invalid journey date.");
          return;
        }
      }

    }else{
      console.log();
    }






    if (
      selectedSource != null &&
      selectedDestination != null &&
      selectedFromDate != null
    ) {
      // console.log(selectedSource);
      // console.log(selectedDestination);
      // console.log(fromDateRef.current.innerHTML);
      // console.log(toDateRef.current.innerHTML);

      const payload = {
        source: JSON.stringify(selectedSource),
        destination: JSON.stringify(selectedDestination),
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      };

      //console.log(payload);

      const urldata = new URLSearchParams(payload);
      //console.log(urldata.toString());

      const tripslug = `${selectedSource.CityName}-to-${selectedDestination.CityName}`;
     
      var deviceId = null;
      var deviceDaySession = null

      if (
            PlatformDetector.isAndroidWebView() ||     PlatformDetector.isIOSWebView()
          ){
      
             if(window.RegistrationUniqueIDFromMobile ){
                    deviceId =window.RegistrationUniqueIDFromMobile;
                }
          
                if(window.SessionUniqueIDFromMobile){
                   deviceDaySession = {sessionId:window.SessionUniqueIDFromMobile}; 
                }
      
          }else{

                if(window.SessionConstants.DEVICE_INFO_KEY ){
                    deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
                    
                }

                if(window.SessionConstants.DEVICE_SESSION_KEY){
                  deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
                  deviceDaySession = deviceDaySession ? deviceDaySession.sessionId : null;
                }
        }

      if(autoSearchMode == 0){
          const parameters ={
            source: selectedSource,
            destination: selectedDestination,
            fromDate: selectedFromDate,
            toDate: selectedToDate,
            RegistrationUniqueID : deviceId,
            SessionUniqueID :deviceDaySession
          }
          window.dispatchEvent(new CustomEvent("postphoneSearch", { detail: parameters }));
      }else{
        window.location.href = `${BookingPageUrl}/${tripslug}?${urldata.toString()}&RegistrationUniqueID=${deviceId}&SessionUniqueID=${deviceDaySession.sessionId}`; 
      }

      
    }else{
      alert("Please select Source, Destination and Journey date to search");
    }
  };

  const handleModifySearch = () => {
    sendEventTobackend("ModifyButtonClicked",null,1);
    if(selectedToDate != null ){
      if(selectedFromDate == null || selectedFromDate == ''){
        alert('Please select Valid Journey date');
        return;
      }else{
        console.log(selectedFromDate);
        console.log(selectedToDate);
        const frmdt = selectedFromDate.replace(/[/-]/g, "-");
        const todt = selectedToDate.replace(/[/-]/g, "-");

        const reversedFrm = frmdt.split("-").reverse().join("-");
        const reversedTo = todt.split("-").reverse().join("-");  

        console.log(reversedFrm);
        console.log(reversedTo);

        const date1 = new Date(reversedFrm);
        const date2 = new Date(reversedTo);

        if (date1 >= date2) {
          alert("Invalid journey date.");
          return;
        }
      }

    }else{
      console.log();
    }
    
    if (
      selectedSource != null &&
      selectedDestination != null &&
      selectedFromDate != null
    ) {
      // console.log(selectedSource);
      // console.log(selectedDestination);
      // console.log(fromDateRef.current.innerHTML);
      // console.log(toDateRef.current.innerHTML);

      const payload = {
        source: JSON.stringify(selectedSource),
        destination: JSON.stringify(selectedDestination),
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      };

    //  console.log(payload);

      onSearchModify(payload);

      // const urldata = new URLSearchParams(payload);
      // console.log(urldata.toString());

      // const tripslug = `${selectedSource.CM_CityName}-to-${selectedDestination.CM_CityName}`;

      //  window.location.href = `${BookingPageUrl}/${tripslug}?${urldata.toString()}`;
    }
  };



//   const  sendEventTobackend = async (eventName, eventValue , eventFrom ) =>{
//       const TrviaAndMisData = MISBookingMode();
//       let deviceId = null;
//       let deviceDaySession = null

//       if(window.SessionConstants.DEVICE_INFO_KEY ){
//           deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
//       }

//       if(window.SessionConstants.DEVICE_SESSION_KEY){
//          deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
//       }
       
//       console.log(eventName);
//       console.log(toSafeString(eventValue));
//       console.log(eventFrom);
//       console.log(deviceId);
//       console.log(deviceDaySession);


//       const payload = {
//         RegistrationUniqueID : deviceId,
//         SessionUniqueID :deviceDaySession.sessionId,
//         MobileNumber : "",
//         EventName : toSafeString(eventName),
//         TRVia : TrviaAndMisData.deviceType
//       }


//       const response = await axios.post('/send-event-to-backend', payload, {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       });

//       console.log(response);


//   }


//   function toSafeString(value) {
//   if (value === null || value === undefined) {
//     return "";
//   }

//   if (typeof value === "string") {
//     return value;
//   }

//   try {
//     return JSON.stringify(value);
//   } catch (e) {
//     return String(value);
//   }
// }




  return (
    <section className="common-booking-section">
      <div id={containerId} className="common-booking-container"> 
        <div className="container">
          
          <div className="common-booking-content">
            <div className="common-source-destination-section">
              {isMobile ? (
                <>
                  {/* Small screen version */}
                  <div className="common-sd-input-section">
                    <div className="common-source" style={{ padding: "0px 0px" }}>
                      <div onClick={() => {setOpenSource(true);sendEventTobackend("SourceClicked", null, 2);}}>
                        <TextField
                          value={selectedSource?.CityName || ""}
                          placeholder="Source"
                          fullWidth
                          size="small"
                          className="autocomplete-input2"
                          sx={{
                            ".MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            ".MuiInput-underline:after": {
                              borderBottom: "none",
                            },
                            ".MuiInput-underline:before": {
                              borderBottom: "none",
                            },
                            ".MuiFilledInput-underline:after": {
                              borderBottom: "none",
                            },
                            ".MuiFilledInput-underline:before": {
                              borderBottom: "none",
                            },

                            ".autocomplete-input2": {
                              color: "#1f1f1f",
                              fontWeight: "bold",
                              paddingLeft: "20px",
                            },
                          }}
                          InputProps={{
                            readOnly: true, // Make the input field read-only
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="swap-icon"
                      onClick={() => handleSwap()}
                    ></div>
                    <div className="common-destination" style={{ padding: "0px 0px" }}>
                      <div onClick={() =>{setOpenDestination(true);sendEventTobackend("DestinationClicked", null, 2);}}>
                        <TextField
                          value={selectedDestination?.CityName || ""}
                          placeholder="Destination"
                          fullWidth
                          size="small"
                          className="autocomplete-input2"
                          sx={{
                            ".MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            ".MuiInput-underline:after": {
                              borderBottom: "none",
                            },
                            ".MuiInput-underline:before": {
                              borderBottom: "none",
                            },
                            ".MuiFilledInput-underline:after": {
                              borderBottom: "none",
                            },
                            ".MuiFilledInput-underline:before": {
                              borderBottom: "none",
                            },

                            ".autocomplete-input2": {
                              color: "#1f1f1f",
                              fontWeight: "bold",
                              paddingLeft: "20px",
                            },
                          }}
                          InputProps={{
                            readOnly: true, // Make the input field read-only
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <BookingSectionAutoCmplSmallScreen
                    open={openSource}
                    onClose={() => setOpenSource(false)}
                    value={selectedSource}
                    setValue={setSelectedSource}
                    cityData={processedCityData}
                    fuse={fuse}
                    label={"Source"}
                  />

                  <BookingSectionAutoCmplSmallScreen
                    open={openDestination}
                    onClose={() => {
                      setOpenDestination(false);
                      if (onChangeDestinationConfigUrl != null) {
                        axios
                          .get(onChangeDestinationConfigUrl, {
                            headers: {
                              "Content-Type": "application/json",
                            },
                          })
                          .then((res) => {
                           // console.log(res);

                            if (res.data) {
                              if (config) {
                                const mconfig = merge({}, config, res.data);

                                //console.log(mconfig);
                                setDConfig(mconfig);
                              } else {
                               // console.log("local data not available");
                              }
                            }
                          })
                          .catch((err) => {
                           // console.log(err);
                          });
                      }
                    }}
                    value={selectedDestination}
                    setValue={setSelectedDestination}
                    cityData={processedCityData}
                    fuse={fuse}
                    label={"Destination"}
                  />
                </>
              ) : (
                <>
                  {/* Desktop version */}
                  <div className="common-sd-input-section">
                    <div
                      className="common-source"
                      style={{ padding: "0px 0px" }}
                      ref={sourceContainerRef}
                    >

                      <Autocomplete
                        
                        onClose={()=>{
                          setIsSourceOpen(false);
                          // setIsDestinationOpen(true);
                          // console.log('close id done');
                          // open destination after small delay


                           // small delay lets MUI finish closing
                          sendEventTobackend("SourceClicked", selectedSource, 1);
                        
                        } }
                        onOpen={()=>{setIsSourceOpen(true);setIsDestinationOpen(false);  }}
                        value={selectedSource}
                        open={isSourceOpen}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            setSelectedSource(newValue);
                            setTimeout(() => {
                            setIsDestinationOpen(true);
                           // now safely focus destination input
                           // console.log('focus destination input');
                            if (destinationInputRef.current) {
                              const input = destinationInputRef.current.querySelector('input');
                              input?.focus();
                            }
                          }, 250);
                          }else{
                            setSelectedSource(null);
                          }
                        }}
                       
                        // onInputChange={(e, value) => setInputSource(value)}
                        onInputChange={(e, value) => debouncedSourceSearch(value)}
                        filterOptions={filterSourceOptions}
                        forcePopupIcon={false}
                        options={searchSourceResults}

                        sx={{              
                                  '.MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                    
                                  },              
                                  '.MuiInput-underline:after': {
                                    borderBottom: 'none',
                                    
                                  },
                                  '.MuiInput-underline:before': {
                                    borderBottom: 'none',
                                    
                                  },             
                                  '.MuiFilledInput-underline:after': {
                                    borderBottom: 'none',
                                    
                                  },
                                  '.MuiFilledInput-underline:before': {
                                    borderBottom: 'none',
                                    
                                  },
                                   
                                   paddingRight:'40px'
                                  
                    
                                  
                    
                    
                                }}




                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option.inputValue || option.CityName
                        }
                        renderOption={(props, option) => (
                          <li key={option.CityID} {...props}>
                            <div className="autocomplete-item" style={{color:'#1f1f1f'}}>
                             {
                                !option.isBoardingPoint ? (
                             
                                <small className="icon">
                                <FaTreeCity />
                                </small>):(<small className="icon" style={{paddingLeft: '20px'}}>
                                <MdLocationPin />
                                </small>)}
                                
                                {option.CityName}

                            </div>

                            
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={""}
                            placeholder="Source"
                            size="small"
                            className="autocomplete-input2"
                            
                             InputLabelProps={{
                                            ...params.InputLabelProps,
                                            sx: {
                                            ...params.InputLabelProps.sx, 
                                            color: '#1f1f1f',
                                            fontWeight: 'bold',
                                            paddingLeft: '20px',
                                            // Change color on focus
                                            '&.Mui-focused': {
                                                color: '#150E2D',
                                            },
                                            },
                                        }}
                          />
                        )}
                      />

                    

                    </div>
                    <div
                      className="swap-icon"
                      onClick={() => handleSwap()}
                    ></div>
                    <div
                      className="common-destination"
                      style={{ padding: "0px 0px" }}
                      ref={destinationContainerRef}
                    >
                      <Autocomplete
                        value={selectedDestination}
                        onClose={() => {setIsDestinationOpen(false);sendEventTobackend("DestinationClicked", selectedDestination, 1);}}
                        onOpen={() => {
                          setIsDestinationOpen(true);
                          setOpenOnDestSelect(false);
                        }}
                        open={isDestinationOpen}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            setSelectedDestination(newValue);
                            setTimeout(() => {
                              setOpenOnDestSelect(true);
                            }, 100);

                            if (onChangeDestinationConfigUrl != null) {
                              axios
                                .get(onChangeDestinationConfigUrl, {
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                })
                                .then((res) => {
                                 // console.log(res);

                                  if (res.data) {
                                    if (config) {
                                      const mconfig = merge(
                                        {},
                                        config,
                                        res.data
                                      );

                                      //console.log(mconfig);
                                      setDConfig(mconfig);
                                    } else {
                                      console.log("local data not available");
                                    }
                                  }
                                })
                                .catch((err) => {
                                  console.log(err);
                                });
                            }
                          } else {
                            setSelectedDestination(null);
                          }
                        }}
                        onInputChange={(e, value) =>
                          debouncedDestinationSearch(value)
                        }
                        filterOptions={filterDestinationOptions}
                        forcePopupIcon={false}
                        options={searchDestinationResults}
                        sx={{
                          ".MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          ".MuiInput-underline:after": {
                            borderBottom: "none",
                          },
                          ".MuiInput-underline:before": {
                            borderBottom: "none",
                          },
                          ".MuiFilledInput-underline:after": {
                            borderBottom: "none",
                          },
                          ".MuiFilledInput-underline:before": {
                            borderBottom: "none",
                          },
                        }}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option.inputValue || option.CityName
                        }
                        renderOption={(props, option) => (
                          <li key={option.CityID} {...props}>
                            <div className="autocomplete-item">
                              { !option.isBoardingPoint ? (
                                <small className="icon">
                                  <FaTreeCity />
                                </small>
                              ) : (
                                <small
                                  className="icon"
                                  style={{ paddingLeft: "20px" }}
                                >
                                  <MdLocationPin />
                                </small>
                              )}  

                              {option.CityName}
                            </div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={""}
                            placeholder="Destination"
                            size="small"
                            className="autocomplete-input2"
                            ref={destinationInputRef}
                            InputLabelProps={{
                              ...params.InputLabelProps,
                              sx: {
                                ...params.InputLabelProps.sx,
                                color: "#1f1f1f",
                                fontWeight: "bold",
                                paddingLeft: "20px",
                                // Change color on focus
                                "&.Mui-focused": {
                                  color: "#150E2D",
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Date pickers */}
              <div className="common-datepickers-section">
                <div className="common-datepickers">
                  {/* <input
                    type="text"
                    ref={fromDateRef}
                    id="from-date"
                    placeholder="11-09-2025"
                  /> */}
                  <div className="common-input-element" ref={fromDateRef}>
                    {" "}
                    <span style={{ color: "#1c1c1c" }}> {currentDate} </span>
                  </div>

                  <VDatePicker4b
                    targetRef={fromDateRef}
                    onDateSelect={(date) => {
                      setSelectedFromDate(date);
                      //fromDateRef.current.innerHTML = date;

                      //console.log(date);
                      const parts = date.split(/\D+/);
                     // console.log(parts);
                      var day = parseInt(parts[0]);
                      var month = parseInt(parts[1]);
                      var year = parseInt(parts[2]);
                      if (monthDisplayType == "number") {
                        fromDateRef.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                      } else {
                        var dateObject = new Date(year, month - 1, day);
                        //console.log(dateObject);
                        const options = { month: "short" };
                        const monthName = new Intl.DateTimeFormat(
                          "en-US",
                          options
                        ).format(dateObject);
                        fromDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                      }
                      sendEventTobackend("OnwardDateClicked", date , 1);
                    }}
                    minDate={"10/01/2024"}
                    configFromApi={dconfig ? dconfig : null}
                    type="text"
                    openOnClose={openOnDestSelect}
                  />

                  {/* <VDatePicker4b
                    targetRef={toDateRef}
                    onDateSelect={(date) => {
                      //toDateRef.current.innerHTML = date;

                      setSelectedToDate(date);
                      const parts = date.split(/\D+/);
                     // console.log(parts);
                      var day = parseInt(parts[0]);
                      var month = parseInt(parts[1]);
                      var year = parseInt(parts[2]);
                      if (monthDisplayType == "number") {
                        toDateRef.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                      } else {
                        var dateObject = new Date(year, month - 1, day);
                       // console.log(dateObject);
                        const options = { month: "short" };
                        const monthName = new Intl.DateTimeFormat(
                          "en-US",
                          options
                        ).format(dateObject);
                        toDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                      }
                      sendEventTobackend("ReturnDateClicked", date , 1);
                    }}
                    minDate={"10/01/2024"}
                    configFromApi={dconfig ? dconfig : null}
                  /> */}
                  {/* <div className="input-element" ref={toDateRef}>
                    {" "}
                    <span style={{ color: "#A1A1A1", fontWeight: 400 }}>
                      Return
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="common-search-button-section">
                {componentName == "home" ? (
                  <button
                    className="common-search-button"
                    onClick={() => {
                      handleOnSearchClick();
                    }}
                  >
                    Search
                  </button>
                ) : (
                  <button
                    className="common-search-button"
                    onClick={() => {
                      handleModifySearch();
                    }}
                  >
                    {" "}
                    <CiSearch />{" "}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonSearchDateSection;
